module.exports = __webpack_public_path__ + "img/google.cea2cdc7.svg";